var render, staticRenderFns
import script from "./BaseDatePicker.vue?vue&type=script&lang=ts&"
export * from "./BaseDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDatePicker.vue?vue&type=style&index=0&id=8785aac0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8785aac0",
  null
  
)

export default component.exports